(function() {
  'use strict';

  var tracker = document.getElementById('lnc-tracker');
  if (!tracker) return;

  var token = tracker.dataset.apiToken;
  var proxyUrl = tracker.dataset.proxyUrl;
  var input = document.getElementById('lnc-awb-input');
  var btn = document.getElementById('lnc-track-btn');
  var results = document.getElementById('lnc-track-results');
  var contentEl = document.getElementById('lnc-track-content');
  var loadingEl = document.getElementById('lnc-track-loading');
  var errorEl = document.getElementById('lnc-track-error');

  var CACHE_TTL = 5 * 60 * 1000;

  /* ── Canonical 5-step journey (design's fixed milestone list) ── */
  var JOURNEY_TITLES = ['Order confirmed', 'Cut & packed', 'In transit', 'Out for delivery', 'Delivered'];

  /* Delhivery status label → journey rank. */
  function statusRank(label) {
    switch (label) {
      case 'Delivered': return 4;
      case 'Out for Delivery': return 3;
      case 'In Transit': return 2;
      case 'Issue': return 2; /* exceptions happen mid-transit */
      case 'Picked Up': return 1;
      default: return 0; /* Processing / confirmed */
    }
  }

  /* ── Status mapping (scan type/description → label) ── */
  function mapStatus(scanType, scan) {
    var s = (scanType || '').toLowerCase();
    var desc = (scan || '').toLowerCase();
    if (s === 'delivered' || desc.indexOf('delivered') > -1) return { label: 'Delivered' };
    if (desc.indexOf('out for delivery') > -1) return { label: 'Out for Delivery' };
    if (s === 'in transit' || desc.indexOf('transit') > -1 || desc.indexOf('reached') > -1 || desc.indexOf('connected') > -1 || desc.indexOf('dispatched') > -1) return { label: 'In Transit' };
    if (s === 'manifested' || desc.indexOf('manifested') > -1 || desc.indexOf('picked') > -1) return { label: 'Picked Up' };
    if (desc.indexOf('rto') > -1 || desc.indexOf('return') > -1 || desc.indexOf('exception') > -1 || desc.indexOf('undelivered') > -1) return { label: 'Issue' };
    return { label: 'Processing' };
  }

  /* ── Helpers ── */
  function formatDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var h = d.getHours(), m = d.getMinutes(), ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return months[d.getMonth()] + ' ' + d.getDate() + ' · ' + h + ':' + (m < 10 ? '0' : '') + m + ' ' + ampm;
  }

  function formatDateShort(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
  }

  function timeAgo(dateStr) {
    var d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    var mins = Math.round((Date.now() - d.getTime()) / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return mins + ' min ago';
    var hrs = Math.round(mins / 60);
    if (hrs < 24) return hrs + (hrs === 1 ? ' hour ago' : ' hours ago');
    var days = Math.round(hrs / 24);
    return days + (days === 1 ? ' day ago' : ' days ago');
  }

  function titleCase(str) {
    return (str || '').replace(/_/g, ' ').toLowerCase()
      .replace(/\b\w/g, function(c) { return c.toUpperCase(); });
  }

  var _esc = document.createElement('div');
  function escapeHtml(str) { _esc.textContent = str == null ? '' : str; return _esc.innerHTML; }

  /* ── Caching ── */
  function getCache(awb) {
    try {
      var cached = JSON.parse(sessionStorage.getItem('lnc_track_' + awb));
      if (cached && Date.now() - cached.ts < CACHE_TTL) return cached.data;
    } catch (e) {}
    return null;
  }
  function setCache(awb, data) {
    try { sessionStorage.setItem('lnc_track_' + awb, JSON.stringify({ ts: Date.now(), data: data })); } catch (e) {}
  }

  /* ── State toggles ── */
  function showLoading() {
    errorEl.style.display = 'none';
    contentEl.style.display = 'none';
    loadingEl.style.display = 'block';
    results.style.display = 'block';
  }
  function showError(msg) {
    loadingEl.style.display = 'none';
    contentEl.style.display = 'none';
    results.style.display = 'none';
    errorEl.textContent = msg;
    errorEl.style.display = 'block';
  }

  /* ── Headline from status ── */
  function buildHeadline(label, city, day) {
    var near = city ? ' — <em>near ' + escapeHtml(titleCase(city)) + ',</em>' : '';
    switch (label) {
      case 'Delivered':        return 'Delivered — <em>enjoy the fit.</em>';
      case 'Out for Delivery': return 'Out for delivery' + near + ' arriving today.';
      case 'Issue':            return "A hiccup in transit — <em>we're on it.</em>";
      case 'Picked Up':        return 'Packed and picked up' + (day ? ', <em>arriving ' + escapeHtml(day) + '.</em>' : '.');
      case 'In Transit':       return 'On the move' + near + (day ? ' arriving ' + escapeHtml(day) + '.' : '.');
      default:                 return "Order confirmed — <em>we're preparing it.</em>";
    }
  }

  /* ── Render everything from a Delhivery response ── */
  function renderAll(data) {
    /* Delhivery nests under ShipmentData[0].Shipment (proxy may wrap in data[0]). */
    var wrapper = null;
    if (data.ShipmentData && data.ShipmentData[0]) wrapper = data.ShipmentData[0];
    else if (data.data && data.data[0] && data.data[0].ShipmentData) wrapper = data.data[0].ShipmentData[0];
    var shipment = wrapper && wrapper.Shipment ? wrapper.Shipment : wrapper;

    if (!shipment || (!shipment.Scans && !shipment.Status)) {
      showError('No tracking found for that number. Check your confirmation email, or WhatsApp us and we’ll dig it out.');
      return;
    }

    /* Scans newest-first. */
    var scans = (shipment.Scans || []).map(function(sc) {
      var d = sc.ScanDetail || sc;
      return {
        datetime: d.ScanDateTime,
        type: d.ScanType || '',
        description: d.Scan || d.Instructions || '',
        location: d.ScannedLocation || ''
      };
    }).reverse();

    var statusText = (shipment.Status && shipment.Status.Status) ? shipment.Status.Status : '';
    var current = statusText ? mapStatus('', statusText)
      : (scans.length ? mapStatus(scans[0].type, scans[0].description) : { label: 'Processing' });

    var awb = shipment.AWB || (input.value || '').trim();
    var dest = shipment.Destination || '';
    var origin = shipment.Origin || (scans.length ? scans[scans.length - 1].location : '');
    var currentLoc = scans.length ? scans[0].location : dest;
    var delDate = shipment.ExpectedDeliveryDate || shipment.DeliveryDate || shipment.DestRecieveDate || '';
    var delShort = delDate ? formatDateShort(delDate) : '';
    var carrierUrl = 'https://www.delhivery.com/track/package/' + encodeURIComponent(awb);

    var currentRank = scans.reduce(function(max, sc) {
      return Math.max(max, statusRank(mapStatus(sc.type, sc.description).label));
    }, statusRank(current.label));

    /* — status headline + spec — */
    document.getElementById('lnc-stat-eyebrow').textContent =
      awb + (scans.length ? ' · updated ' + timeAgo(scans[0].datetime) : '');
    document.getElementById('lnc-stat-headline').innerHTML = buildHeadline(current.label, currentLoc, delShort);

    document.getElementById('lnc-spec-status').textContent = current.label;
    document.getElementById('lnc-spec-eta').textContent = current.label === 'Delivered' ? 'Delivered' : (delShort || 'In progress');
    var awbLink = document.getElementById('lnc-spec-awb');
    awbLink.textContent = awb || '—';
    awbLink.href = carrierUrl;
    document.getElementById('lnc-spec-shipto').textContent = dest ? titleCase(dest) : (currentLoc ? titleCase(currentLoc) : '—');

    /* — journey line — */
    var steps = document.querySelectorAll('#lnc-jr-steps .jr__s');
    for (var i = 0; i < steps.length; i++) {
      var rank = +steps[i].getAttribute('data-rank');
      steps[i].classList.remove('done', 'active');
      if (rank < currentRank) steps[i].classList.add('done');
      else if (rank === currentRank) steps[i].classList.add('active');
      /* time = latest scan mapping to this milestone rank */
      var t = steps[i].querySelector('time');
      t.textContent = '';
      if (rank <= currentRank) {
        for (var j = 0; j < scans.length; j++) {
          if (statusRank(mapStatus(scans[j].type, scans[j].description).label) === rank && scans[j].datetime) {
            t.textContent = formatDate(scans[j].datetime); break;
          }
        }
      }
    }
    var pct = Math.round((currentRank / 4) * 100) + '%';
    var fill = document.getElementById('lnc-jr-fill');
    fill.style.setProperty('--jr-progress', '0%');
    setTimeout(function() { fill.style.setProperty('--jr-progress', pct); }, 60);

    /* — checkpoint history (future/up → now → past/done) — */
    var rows = '';
    for (var r = 4; r > currentRank; r--) { /* expected future milestones */
      rows += '<div class="hist__row up"><time>—</time>' +
        '<div class="hist__ev"><b>' + escapeHtml(JOURNEY_TITLES[r]) + '</b>Expected</div>' +
        '<div class="hist__loc">' + (dest ? escapeHtml(titleCase(dest)) : 'Upcoming') + '</div></div>';
    }
    scans.forEach(function(sc, idx) {
      var cls = idx === 0 ? ' now' : '';
      var d = sc.datetime ? new Date(sc.datetime) : null;
      var timeHtml = d && !isNaN(d.getTime())
        ? formatDate(sc.datetime).replace(' · ', '<b>') + '</b>'
        : '<b>—</b>';
      rows += '<div class="hist__row' + cls + '"><time>' + timeHtml + '</time>' +
        '<div class="hist__ev"><b>' + escapeHtml(sc.description || 'Scan') + '</b>' +
        (idx === 0 ? 'Latest checkpoint' : 'Checkpoint') + '</div>' +
        '<div class="hist__loc">' + escapeHtml(titleCase(sc.location) || '—') + '</div></div>';
    });
    if (!scans.length) {
      rows += '<div class="hist__row now"><time><b>—</b></time><div class="hist__ev"><b>' +
        escapeHtml(current.label) + '</b>Awaiting first scan</div><div class="hist__loc">—</div></div>';
    }
    document.getElementById('lnc-hist').innerHTML = rows;
    document.getElementById('lnc-hist-count').textContent =
      (scans.length || 0) + (scans.length === 1 ? ' event · refreshed hourly' : ' events · refreshed hourly');
    document.getElementById('lnc-hist-log').href = carrierUrl;

    /* — stylized route map labels + live card — */
    document.getElementById('lnc-rmap-a').textContent = origin ? titleCase(origin) : 'Atelier, Delhi';
    document.getElementById('lnc-rmap-b').textContent = currentLoc ? titleCase(currentLoc) : current.label;
    document.getElementById('lnc-rmap-c').textContent = dest ? titleCase(dest) : 'Your door';
    document.getElementById('lnc-rmap-awb').textContent = 'AWB ' + (awb || '—');
    document.getElementById('lnc-route-dest').textContent = (dest ? titleCase(dest) : 'your door') + '.';

    /* oline: no product data from an AWB lookup — omit gracefully (stays hidden). */

    loadingEl.style.display = 'none';
    errorEl.style.display = 'none';
    contentEl.style.display = 'block';
    results.style.display = 'block';
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── Track ── */
  function track() {
    var awb = (input.value || '').trim();
    if (!awb) { input.focus(); return; }

    var cached = getCache(awb);
    if (cached) { showLoading(); setTimeout(function() { renderAll(cached); }, 150); return; }

    if (!proxyUrl || !token) {
      showError('Live tracking isn’t configured yet. Add the Delhivery token + proxy URL in the section settings.');
      return;
    }

    showLoading();
    btn.disabled = true;

    var apiUrl = 'https://track.delhivery.com/api/v1/packages/json/?waybill=' + encodeURIComponent(awb) + '&token=' + encodeURIComponent(token) + '&verbose=2';

    fetch(proxyUrl + '?url=' + encodeURIComponent(apiUrl))
      .then(function(r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function(data) { setCache(awb, data); renderAll(data); })
      .catch(function() { showError('We couldn’t reach the carrier. Check your number and try again in a moment.'); })
      .finally(function() { btn.disabled = false; });
  }

  /* Expose for QA/manual render with a stubbed Delhivery payload. */
  window.lncRenderTracking = renderAll;

  btn.addEventListener('click', track);
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); track(); }
  });
})();
